import type { ComponentChildren } from "preact";

export function Footer({ children }: { children?: ComponentChildren }) {
  return (
    <footer class="csb-api-gDXMLZ csb-api-kBqEPL">
      {children}
      <span class="csb-api-gDXMLZ csb-api-hlNCCE csb-api-iAmNcN">
        By continuing, you agree to CodeSandbox{" "}
        <a
          href="https://codesandbox.io/legal/terms"
          rel="noreferrer"
          target="_blank"
        >
          Terms of Service
        </a>
        ,{" "}
        <a
          href="https://codesandbox.io/legal/privacy"
          rel="noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
      </span>
    </footer>
  );
}
